import DOMPurify from 'dompurify';

export default {
  install(app) {
    app.config.globalProperties.$sanitize = function (content, options = {}) {
      return DOMPurify.sanitize(content, options);
    };
  },
};
